export const monarchDemoSite = {
  name: "Monarch Funeral Home & Cremation Services",
  shortName: "Monarch",
  websiteUrl: "https://www.monarchfuneralhome.com",
  phone: "(954) 972-7565",
  address: "2950 N State Rd 7, Margate, FL 33063",
  cityLine: "Serving Margate, Coconut Creek, Coral Springs, and nearby Broward families",
  primaryMessage: "Plan a meaningful service with Monarch",
  supportMessage:
    "Start online, move at your own pace, and our care team will review everything with you.",
  trustCopy:
    "Your selections are saved privately and reviewed by a licensed funeral director before anything is finalized.",
  familyPaths: [
    "Immediate arrangements",
    "Pre-planning",
    "Catholic and faith-based services",
    "Digital service folders",
  ],
  careStats: [
    { value: "24/7", label: "Care team availability" },
    { value: "4", label: "Planning paths" },
    { value: "1", label: "Director-ready case" },
  ],
};
